'use client';
import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import ReactHtmlParser from 'react-html-parser';
import reactHtmlParser from 'react-html-parser';
import Button from '@/components/common/ui/buttons/Button';
import useDeviceTypeMobile from '@/components/hooks/useDeviceTypeMobile';
import Modal from 'react-bootstrap/Modal';
import ContactForm from '@/components/common/ygen/sections/contact-form/ContactForm';
import { StyledJobList } from '@/components/common/ygen/sections/job-list/job-list.style';

const JobList = ({ data, jobList }) => {
	const JobList = jobList;
	const isMobile = useDeviceTypeMobile();
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [modalIsOpenData, setModalIsOpenData] = useState('');
	const JobListShow = data?.section_data?.notitle

	useEffect(() => {
		if (window.location.hash) {
			setModalIsOpen(true);
		}
	}, []);




	return (
		<>
			{
				JobListShow === 0 ?
					<StyledJobList className="JobList" data-scroll-section>

						<Container>

							<Row>
								<Col md={12}>
									{
										data?.section_data?.subtitle &&
										<h3>{ReactHtmlParser(data?.section_data?.subtitle)}</h3>
									}
								</Col>
								<Col md={{ span: 12 }}>

									{
										JobList && JobList?.length > 0 &&
										JobList?.map((job, index) => {
											return (
												<div key={index} className={'job-item-single'}>
													<div className="d-flex justify-content-between title-wrapper">
														<h6>{reactHtmlParser(job?.title)}</h6>
														{
															!isMobile &&
															<Button onClick={(e) => {
																e.preventDefault();
																setModalIsOpenData(job)

																setModalIsOpen(true); // opens modal
															}} color={'#152637'} background={'#152637'} pathColor={'white'} src={`#${job?.slug}`} text={'Apply Now'} />

														}

													</div>
													<div className="d-flex content-wrapper">
														<div className="single-item">
															{ReactHtmlParser(job?.experience)}
														</div>
														<div className="single-item">
															{ReactHtmlParser(job?.overview)}
														</div>
														<div className="single-item">
															{ReactHtmlParser(job?.department)}
														</div>
													</div>
													{
														isMobile &&
														<Button onClick={(e) => {
															e.preventDefault();
															setModalIsOpenData(job)
															window.history.pushState(null, '', `#${e?.slug}`); // updates URL
															setModalIsOpen(true); // opens modal
														}} margin={'30px 0 0'} color={'#152637'} background={'#152637'} pathColor={'white'} src={`#${e?.slug}`} text={'Apply Now'} />

													}
												</div>
											);
										})
									}
								</Col>
							</Row>

						</Container>


						<Modal interest={data?.page_data?.title} className={'modal-video'} show={modalIsOpen} onclick={() => {
							setModalIsOpen(false);
							window.location.hash = ''; // fallback method
						}}>
							<Modal.Body className={'video'}>
								<ContactForm topTitle={'Join Our'} data={modalIsOpenData} bottomTitle={'Team'} asModal career  form_id={'career_form7'}  onclick={() => {
									setModalIsOpen(false);
									window.location.hash = ''; // fallback method
								}}/>
							</Modal.Body>

						</Modal>
					</StyledJobList>

					:
					<ContactForm topTitle={'Join Our'} career bottomTitle={'Team'}  form_id={'career_form7'} />

			}
		</>
	);
};




export default React.memo(JobList);
